export type DeviceLatLng = { lat: number; lng: number };

/** Browser GPS / Wi‑Fi location. Does not use Google or the server IP. */
export function getDeviceLatLng(): Promise<DeviceLatLng> {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && !window.isSecureContext) {
      reject(new Error('Location requires HTTPS. Pick on the map instead.'));
      return;
    }
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      reject(new Error('Geolocation is not supported in this browser.'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      pos => {
        resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude });
      },
      err => {
        if (err.code === err.PERMISSION_DENIED) {
          reject(
            new Error(
              'Location permission denied. Allow location access in your browser, or pick on the map.'
            )
          );
        } else if (err.code === err.TIMEOUT) {
          reject(new Error('Location request timed out. Try again or pick on the map.'));
        } else {
          reject(new Error('Could not determine your device location. Pick on the map instead.'));
        }
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 30_000 }
    );
  });
}
